<script>
  import DateField from '@/components/InputComponents/DateField.vue'
  import PayrollTaxLiabilityList from '@/components/SigmaClientNew/PayrollTaxLiabilityList.vue'
  import { getSimpleDate } from '@/utils/helpers/FormatDate'
  import SigmaQueryLoader from '@/utils/helpers/SigmaQueryLoader'

  export default {
    name: 'PayrollTaxLiability',
    components: {
      DateField,
      PayrollTaxLiabilityList
    },
    data () {
      return {
        iteration: 0,
        taxRowData: undefined,
        allCodes: {
          bank__in: []
        },
        reportOptions: {},
        /*
          transactionStatuses: [ 'posted' ],
          accountQuickPick: 'all',
          type: null,
          dates: 'datesAll',
          sort: 'account',
          status: 'all',
          format: 'pdf',
          currencyFactor: undefined,
          report_currency_id: 1
        },
        */
        selectedCodes: {
          time_posted_start: undefined,
          time_posted_end: undefined
        },
        transactionTypes: {     // Types of transactions and whether we need them or not
          'taxliab': { name: 'TAXLIAB', include: true }
        },
        disableReportRun: false, // Disable run report button if false
        prettyJson: undefined,
        showJson: false,
        loading: false
      }
    },

    computed: {
      includedTypes () {
        return Object.values(this.transactionTypes).filter(types => types.include === true).map(type => type.name)
      },
      width () {
        return '100%'
      },
      height () {
        return window.innerHeight * 0.9 + 'px'
      }
    },
    methods: {
      async getRegisterData () {
        this.taxRowData = []
        // Show status of recent payrolls (posted in the last week ending and open, draft, or audited)

        const options = {
          reportOptions: this.reportOptions,
          selectedCodes: this.selectedCodes,
          includedTypes: this.includedTypes
        }
        let queryLoader = new SigmaQueryLoader(this.$store, options)
        let response = await queryLoader.getReportData('payrollquery')

        this.taxRowData = response.data[0]
      },

      async onGenerateExport () {
        if (!this.taxRowData || this.taxRowData.length === 0) {
          this.createNotification('Error', 'Please select transactions to export.', 'warning', null, null, null, 5000)
          return false
        }

        this.$refs['payroll_check_register'].exportToExcel()
      },

      async refresh () {
        this.taxRowData = undefined
        await this.getRecentPayrolls()
      }
    },

    async created () {
      const today = new Date()
      this.selectedCodes.time_posted_start = getSimpleDate(today.setDate(today.getDate() - today.getDay()), 'yyyy-mm-dd')
      this.selectedCodes.time_posted_end = getSimpleDate(today.setDate(today.getDate() + today.getDay() + 6), 'yyyy-mm-dd')

      this.disableReportRun = true
      try {
        const response = await this.$store.dispatch('fetchBanks')
        if (response.banks && typeof response.banks === 'object') {
          for (const i in response.banks) {
            this.allCodes.bank__in.push(response.banks[i])
          }
        } else {
          throw new Error('Unable to fetch report options')
        }
      } catch (error) {
        console.log(error)
      }
      this.disableReportRun = false
    },

    async mounted () {
      await this.getRegisterData()
    }
  }
</script>

<template>
  <div style="width: 100%;" v-loading.body="loading">
    <el-row type="flex" align="middle" justify="end" class="headerRow">
      <el-col>
        <el-row type="flex" align="middle" justify="start" style="font-size: 1.5em;">
          PAYROLL TAX LIABILITY
        </el-row>
      </el-col>
      <el-col class="small">
          <a @click="showJson = ! showJson">.&nbsp;</a>
      </el-col>
      <el-col>
        <el-row type="flex" align="middle" justify="end">
          <el-tag v-if="disableReportRun" type="primary">
            <el-icon class="is-loading" style="margin: 0 6px;"><Loading/></el-icon>Running
          </el-tag>
          <el-button type="warning" plain @click="getRegisterData" :disabled="disableReportRun">Refresh</el-button>
          <el-button v-if="taxRowData && taxRowData.length" type="success" @click="onGenerateExport" :disabled="disableReportRun" style="margin: 0 15px;">Save</el-button>
        </el-row>
      </el-col>
    </el-row>
    <el-row type="flex" align="middle" justify="start" class="headerRow">
      <el-row type="flex" align="middle" justify="end">
        <el-col :span="6">Posting Date Start</el-col>
        <el-col :span="6">
          <DateField v-model="selectedCodes.time_posted_start" />
        </el-col>
        <el-col :span="6">Posting Date End</el-col>
        <el-col :span="6">
          <DateField v-model="selectedCodes.time_posted_end" />
        </el-col>
        <el-col :span="6">Bank</el-col>
        <el-col :span="6">
          <el-select v-model="selectedCodes.bank_id" :multiple="false" placeholder="Bank Account">
            <el-option
              v-for="opt in allCodes.bank__in"
              :key="opt.id"
              :label="opt.name"
              :value="opt.id">
            </el-option>
          </el-select>
        </el-col>
      </el-row>
    </el-row>
    <el-row>
      <el-col>
        <payroll-tax-liability-list
          name="payroll_tax-liability"
          ref="payroll_tax-liability"
          :key="iteration"
          :width="width"
          :height="height"
          :row-data="taxRowData"
        />
      </el-col>
    </el-row>

  </div>
</template>

<style scoped>
  .small { font-size: 8px; }
  .right { float: right; text-align: right; padding: 0px 5px; }
  .left { float: left; text-align: left; padding: 0px 5px; }
  .selectRow { padding: 0px 20px; }
  .section { padding: 40px 20px 0px;  }
  .headerRow { padding: 15px 20px 0px; }
  .m-top-20 { margin-top: 20px; }
  .m-right-20 { margin-right: 20px; }
</style>
<style>
  .el-select { display: block; }
  .el-transfer-panel { width:36%; max-width: 350px }
  .el-transfer-panel__body { min-height: 400px }
  .el-transfer-panel__list { min-height: 360px }
  /* border: 1px solid #d1dbe5; box-shadow: 0 2px 4px rgba(0, 0, 0, .12),0 0 6px rgba(0, 0, 0, .04); display: inline-block; width: 30%; position: relative; height: 500px; */
</style>
